import React from 'react'
import styled from '@emotion/styled'
import Button from '@groovehq/internal-design-system/lib/components/Button/Button'
import ReplyIcon from '@groovehq/internal-design-system/lib/assets/icons/Reply'
import ReplyAllIcon from '@groovehq/internal-design-system/lib/assets/icons/ReplyAll'
import { css } from '@emotion/react'

import { SUI, Dropdown } from 'shared/ui'
import { propFunc } from 'util/functions'

const forwardStyle = css`
  transform: scaleX(-1);
`

const dropdownMenuIconStyle = theme => css`
  margin-right: ${theme.spacing[5]};
  font-size: ${theme.fontSize.x4large};
  color: ${theme.color.monochrome.mediumDark};
`

const buildOptions = (
  onReplyAll,
  onDirectMessage,
  onForward,
  { isReplyingAllActive, isReplyingDirectActive, isForwardingActive }
) => {
  return [
    {
      key: 'reply-all',
      content: (
        <React.Fragment>
          <ReplyAllIcon css={dropdownMenuIconStyle} /> Reply all
        </React.Fragment>
      ),
      onClick: onReplyAll,
      value: 'reply-all',
      active: isReplyingAllActive,
    },
    {
      key: 'reply-direct',
      content: (
        <React.Fragment>
          <ReplyIcon css={dropdownMenuIconStyle} /> Direct reply
        </React.Fragment>
      ),
      onClick: onDirectMessage,
      value: 'reply-direct',
      active: isReplyingDirectActive,
    },
    {
      key: 'forwarding',
      content: (
        <React.Fragment>
          <ReplyIcon css={[forwardStyle, dropdownMenuIconStyle]} /> Forward
        </React.Fragment>
      ),
      onClick: onForward,
      value: 'forward',
      active: isForwardingActive,
    },
  ]
}

class SwitcherButton extends React.PureComponent {
  onReplyAll = () => {
    const { doOpenTicketPage, isExpanded, onReplyAllClick } = this.props
    // this switch is a workaround until the old editor is thrown out, at which point we will throw out the second branch and just work on callbacks
    if (onReplyAllClick) {
      onReplyAllClick()
    } else {
      doOpenTicketPage(isExpanded)
    }
  }

  onDirectMessage = () => {
    const {
      isExpanded,
      onDirectMessageClick,
      doOpenReplyDirectPage,
    } = this.props
    if (onDirectMessageClick) {
      onDirectMessageClick()
    } else {
      doOpenReplyDirectPage(isExpanded)
    }
  }

  onForward = () => {
    const { onForwardClick, doOpenForwardPageExpanded } = this.props
    if (onForwardClick) {
      onForwardClick()
    } else {
      doOpenForwardPageExpanded()
    }
  }

  render() {
    const { className, isExpanded, isForwarding, replyType } = this.props
    const isReplyingAllActive = false
    const isReplyingDirectActive = false
    const isForwardingActive = false
    return (
      <SUI>
        <Dropdown
          className={className}
          options={propFunc(
            buildOptions,
            this.onReplyAll,
            this.onDirectMessage,
            this.onForward,
            {
              isReplyingAllActive,
              isReplyingDirectActive,
              isForwardingActive,
              expand: isExpanded,
            }
          )()}
          trigger={
            <Button type="icon" size="small">
              {replyType === 'reply-all' && !isForwarding && <ReplyAllIcon />}
              {replyType === 'reply-direct' && !isForwarding && <ReplyIcon />}
              {isForwarding && <ReplyIcon css={forwardStyle} />}
            </Button>
          }
        />
      </SUI>
    )
  }
}

export default styled(SwitcherButton)`
  &&& {
    align-items: center;
    color: ${props => props.theme.color.monochrome.superDark};
    cursor: pointer;
    display: inline-flex;
    margin-left: -6px;
    margin-right: 8px;
    color: var(--color-monochrome-mediumDark);

    button {
      overflow: visible;
      &::before {
        right: -12px;
      }
    }

    &:hover {
      color: ${props => props.theme.color.primary.brand};
    }

    .dropdown {
      &.icon {
        line-height: 1;
        font-size: 8px !important;
        margin-left: -4px !important;
        z-index: 1;
        pointer-events: none;
        color: var(--color-monochrome-mediumDark) !important;
        &.active,
        &:active,
        &:hover {
          color: var(--color-monochrome-mediumDark) !important;
        }
      }
    }

    .menu .item {
      padding-left: 6px !important;
    }
  }
`
